import * as Yup from 'yup';
import { FundraisingTypes } from 'src/constants/FundraisingTypes';
import { FundraisingLanguages } from 'src/constants/FundraisingLanguages';
import {
  idFieldRequired, moneyField, moneyFieldLogic, slugField,
} from 'src/lib/ValidatorHelper';

const FundraisingInfoValidator = () => Yup.object().shape({
  type: Yup.string()
    .oneOf(Object.values(FundraisingTypes)),
  name: Yup.string()
    .required(),
  slug: slugField()
    .required(),
  active: Yup.boolean(),
  default_language: Yup.string()
    .test('is-languages', 'not a languages', function () {
      return Object.values(FundraisingLanguages).includes(this.parent.default_language);
    }),
  start_date: Yup.date(),
  end_date: Yup.date(),
  has_end: Yup.boolean(),
  program_id: idFieldRequired(),
  department_id: idFieldRequired(),
  account_id: idFieldRequired(),
  bank_account_id: idFieldRequired(),
  payment_gateway_id: idFieldRequired(),
  group_ids: Yup.array().of(idFieldRequired()),
  //
  ask_for_fee: Yup.boolean(),
  admin_fee: Yup.mixed()
    .when('ask_for_fee', {
      is: true,
      then: (schema) => schema
        .required('Required') // First: make it required
        .test('is-money', 'Invalid amount', moneyFieldLogic), // Then: add money test
      otherwise: (schema) => schema.optional(),
    }),
  //
  show_suggested: Yup.boolean(),
  max_amount: Yup.mixed()
    .when('show_suggested', {
      is: true,
      then: (schema) => schema
        .required('Required') // First: make it required
        .test('is-money', 'Invalid amount', moneyFieldLogic), // Then: add money test
      otherwise: (schema) => schema.optional(),
    }),
  //
  allow_installment: Yup.boolean(),
  max_installment: moneyField().when('allow_installment', {
    is: true,
    then: (schema) => schema.required('Max installment is required'),
    otherwise: (schema) => schema,
  }),
  show_countdown: Yup.boolean(),
  countdown_end_date: Yup.date(),
});

export default FundraisingInfoValidator;
